// Common TLD typos that should be rejected
const INVALID_TLDS = new Set([
    "con",
    "cmo",
    "ocm",
    "coom",
    "comm",
    "comn",
    "conm",
    "coml",
    "col",
    "vom",
    "xom",
    "fom",
    "cim",
    "ckm",
    "clm",
    "nett",
    "ney",
    "met",
    "ner",
    "orgg",
    "ogr",
    "orf",
    "eduu",
    "eud",
    "govv",
    "gob",
    "ioo",
    "ino"
]);

export const emailIsValid = (value = "") => {
    const emailMatch =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))(?<!-)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const passesRegex = emailMatch.test(value);

    const [address, domain] = value.split("@");

    if (!passesRegex || !address || !domain) {
        return false;
    }

    if (address.length >= 65 || domain.length >= 254) {
        return false;
    }

    // Check for common TLD typos
    const tld = domain.split(".").pop()?.toLowerCase();
    if (tld && INVALID_TLDS.has(tld)) {
        return false;
    }

    return true;
};
